/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} News_Meta_Ogdescription1Inputs */

const ja_news_meta_ogdescription1 = /** @type {(inputs: News_Meta_Ogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレイブレーン(PLAYBRAIN)からの最新情報・プレスリリースをお知らせします。`)
};

const en_news_meta_ogdescription1 = /** @type {(inputs: News_Meta_Ogdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Here are the latest news and press releases from PLAYBRAIN.`)
};

/**
* | output |
* | --- |
* | "Here are the latest news and press releases from PLAYBRAIN." |
*
* @param {News_Meta_Ogdescription1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const news_meta_ogdescription1 = /** @type {((inputs?: News_Meta_Ogdescription1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<News_Meta_Ogdescription1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_news_meta_ogdescription1(inputs)
	return en_news_meta_ogdescription1(inputs)
});
export { news_meta_ogdescription1 as "news_meta_ogDescription" }